<template>
  <nav class="dn-gnavi">
    <my-inner device="pc" :dumped="!$store.getters['config/isManabi']" />
    <my-inner device="sp" />
    <dn-bc-banner
      class="dn-gnavi__bc-banner"
      screen="103"
      type="04,05"
    />
  </nav>
</template>



<script>
import MyInner from './GnaviInner';



export default {
  name: 'dn-gnavi',

  components: {
    MyInner,
  },
}
</script>



// WEBPACK FOOTER //
// Gnavi.vue?694e8336